/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DropDownRepositoryResponse } from "../types/DropDownRepositoryResponse.ts";

export const dropDownRepositoryResponseSchema = z.object({
  key: z.optional(
    z
      .number()
      .int()
      .describe(
        "Identificador único do item, utilizado como valor no componente de seleção.",
      ),
  ),
  value: z
    .string()
    .describe("Rótulo exibido ao usuário no componente de seleção.")
    .nullish(),
}) as unknown as ToZod<DropDownRepositoryResponse>;
